// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"21955b7a","195":"d263781a","350":"56f8e9fd","444":"dab08654","477":"2066cf84","585":"7ddcbd63","602":"f6f22150","797":"5cccb9dd"}[chunkId] + ".chunk.css";
};